import React, { useContext } from 'react';
import c from 'classnames';
import CommentCoreBadgeList from '../../../coreBadge/CoreBadgeList/presets/CommentCoreBadgeList';
import { CommentContext } from '../../CommentContext';
import FooterRowLayout from '../../layouts/FooterRowLayout';
import { useButtonConditionals } from './useButtonConditionals';
import LikeButton from '../LikeButton';
import AwardBadgeButton from '../AwardBadgeButton';
import ReplyButton from '../ReplyButton';
import s from './CommentFooter.scss';
/** All of our comment interaction buttons in a nice row. Includes liking, replying, badge awarding, and editing. */ const CommentFooter = ({ canPostComment = true, className })=>{
    const { comment, isCommentVisible } = useContext(CommentContext);
    const { showReplyButton, showAwardBadgeButton, showLikeButton } = useButtonConditionals({
        canPostComment
    });
    if (!isCommentVisible) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(FooterRowLayout, {
        className: className,
        blocks: [
            showReplyButton && /*#__PURE__*/ React.createElement(ReplyButton, {
                key: "reply-button",
                className: c(s['action'], s['action-styled'])
            }),
            showLikeButton && /*#__PURE__*/ React.createElement(LikeButton, {
                key: "like-button",
                className: c(s['action'], s['action-styled'])
            }),
            showAwardBadgeButton && /*#__PURE__*/ React.createElement(AwardBadgeButton, {
                key: "award-badge-button",
                className: c(s['action'], s['action-styled'])
            }),
            /*#__PURE__*/ React.createElement(CommentCoreBadgeList, {
                comment: comment,
                key: "badges"
            })
        ]
    });
};
CommentFooter.displayName = 'CommentFooter';
export default CommentFooter;

//# sourceMappingURL=CommentFooter.js.map